<alaris-dialog [closeAction]="close.bind(this)"
			   [confirmAction]="confirm.bind(this)"
			   [loading$]="service.loading$"
			   size="md">
	<h6 slot="header">{{ 'translation_rules.removingDialog' | translate }}</h6>
	<div slot="content">
		<h3><strong>{{ data.rule.Name }}</strong></h3>
	</div>
</alaris-dialog>